import { fetchIdentidad } from "./http-common";

const cambiarContrasenia = (data: {}) => {
  return fetchIdentidad.put(`/ActualizarContraseniaActual`, data);
};

const politicasContrasenia = () => {
  return fetchIdentidad.get(`/PoliticaContrasenia`);
};

const logout = () => {
  return fetchIdentidad.post(`Logout`, {});
};

const usuarioServicio = {
  cambiarContrasenia,
  politicasContrasenia,
  logout,
};

export default usuarioServicio;
